/**
 * Module-level pub-sub for queue WebSocket events.
 *
 * useQueueWebSocket (mounted once at app root) publishes every event here so
 * any component — even those not on /queue — can subscribe without opening
 * its own WebSocket. Avoids the duplicate-WS problem and lets the accept
 * modal render globally regardless of route.
 */

const subscribers = new Set();

export function subscribeQueueEvents(handler) {
  subscribers.add(handler);
  return () => subscribers.delete(handler);
}

export function publishQueueEvent(event) {
  for (const handler of subscribers) {
    try {
      handler(event);
    } catch (e) {
      console.error('queue event handler error', e);
    }
  }
}
